export default (state) => `<header id="mainHeader">
<h1>${state.title}</h1>
</header>`;